import React, { useState } from 'react';
import DownloadCellContent from '../../../../../../../components/Commons/Tables/DownloadCellContent';
import { FabricationPurchaseOrderService } from '../../../../../../../services/FabricationPurchaseOrder';

interface IDownloadOrderColumnProps {
  contractNumber: string;
  orderId: number;
}

const DownloadOrderColumn: React.FC<IDownloadOrderColumnProps> = ({
  contractNumber,
  orderId
}) => {
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [error, setError] = useState(false);

  const onClickDownloadPDF = () => {
    setLoadingPDF(true);
    setError(false);

    FabricationPurchaseOrderService.downloadPurchaseOrderPDF(orderId)
      .then((fabricationPurchaseOrderBase64) => {
        setLoadingPDF(false);
        const pdfFileName = `Pedido_${contractNumber}_${orderId}`;
        const dataurl =
          'data:text/plain;base64,' + fabricationPurchaseOrderBase64;
        const element = document.createElement('a');
        element.setAttribute('href', dataurl);
        element.setAttribute('download', `${pdfFileName}.pdf`);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      })
      .catch((err) => {
        console.error(err);
        setError(true);
        setLoadingPDF(false);
      });
  };

  return (
    <DownloadCellContent
      error={error}
      loading={loadingPDF}
      onclick={onClickDownloadPDF}
      justifyContent={'flex-start'}
    />
  );
};

export default DownloadOrderColumn;
